import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconRadiusBottomLeft20(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={20}
            height={20}
            className={customClassName}
            name="IconRadiusBottomLeft20"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M3.5 9.25V6.766a.75.75 0 0 0-1.5 0V9.25A8.75 8.75 0 0 0 10.75 18h2.48a.75.75 0 0 0 0-1.5h-2.48A7.25 7.25 0 0 1 3.5 9.25m13.226 3.5a1 1 0 1 1 0 2 1 1 0 0 1 0-2m0-3.5a1 1 0 1 1 0 2 1 1 0 0 1 0-2m0-3.5a1 1 0 1 1 0 2 1 1 0 0 1 0-2m-11-2.5a1 1 0 1 1 2 0 1 1 0 0 1-2 0m4.5-1a1 1 0 1 0 0 2 1 1 0 0 0 0-2m3.5 0a1 1 0 1 0 0 2 1 1 0 0 0 0-2"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconRadiusBottomLeft20);
